"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _feature = require("../feature");
/**
 * @class ProfilerFeature
 * @classdesc provides basic profiling capabilities for named events.
 * @example
 *
 *  runtime.feature('profiler').enable()
 *
 *
 *  runtime.profiler
 *
 *  profiler.start('something')
 *
 *  somethingTakesAMinute().then(() => {
 *    profiler.end('something')
 *  })
 */


var ProfilerFeature =
/*#__PURE__*/
function (_Feature) {
  (0, _inherits2["default"])(ProfilerFeature, _Feature);

  function ProfilerFeature() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ProfilerFeature);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ProfilerFeature)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "shortcut", 'profiler');
    return _this;
  }

  (0, _createClass2["default"])(ProfilerFeature, [{
    key: "observables",
    value: function observables() {
      /**
       * @property {Map} timings
       * @memberof ProfilerFeature
       */
      return {
        timings: ['shallowMap', []]
      };
    }
    /**
     * @param {String} eventName the name of the event you're finished timing
     * @memberof ProfilerFeature
     */

  }, {
    key: "end",
    value: function end(eventName) {
      return this.profileEnd(eventName);
    }
  }, {
    key: "profileEnd",
    value: function profileEnd(eventName) {
      try {
        var stamp = +new Date();
        this.timings.set(eventName, (0, _objectSpread2["default"])({}, this.timings.get(eventName) || {}, {
          end: stamp
        }));
      } catch (error) {}
    }
    /**
     * @param {String} eventName the name of the event you're starting to time
     * @memberof ProfilerFeature
     */

  }, {
    key: "start",
    value: function start(eventName) {
      this.profileStart(eventName);
    }
  }, {
    key: "profileStart",
    value: function profileStart(eventName) {
      var stamp = +new Date();

      try {
        this.timings.set(eventName, {
          start: stamp
        });
      } catch (error) {}

      return stamp;
    }
  }, {
    key: "report",

    /**
     * @typedef {Object} TimingReport
     * @property {Number} start
     * @property {Number} stop
     * @property {Number} duration
     */

    /**
     * @typedef {Object<String, TimingReport>} TimingsReport
     */

    /**
     * @type {TimingsReport}
     */
    get: function get() {
      var timings = this.runtime.convertToJS(this.timings.toJSON());
      return this.chain.plant(timings).pickBy(function (v) {
        return v.start && v.end;
      }).mapValues(function (_ref) {
        var start = _ref.start,
            end = _ref.end;
        return {
          start: start,
          end: end,
          duration: end - start
        };
      }).value();
    }
  }]);
  return ProfilerFeature;
}(_feature.Feature);

exports["default"] = ProfilerFeature;
(0, _defineProperty2["default"])(ProfilerFeature, "shortcut", 'profiler');